import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { InAppMessageService } from 'src/app/core/services/in-app-message.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-verify-pin',
  templateUrl: './verify-pin.page.html',
  styleUrls: ['./verify-pin.page.scss'],
})
export class VerifyPinPage implements OnInit, OnDestroy {
  constructor(
    private modalController: ModalController,
    private authService: AuthService,
    private userService: UserService,
    private inAppMessageService: InAppMessageService,
    private navController: NavController,
    private translateService: TranslateService,
  ) { }

  subscription = new Subscription();
  myPin = null;

  @Input() from;

  ngOnInit() { }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private sendVerifyCode() {
    const userProfile = this.userService.userProfile$.getValue();
    if (userProfile && userProfile.user) {
      const payload = {
        destination: userProfile.user.mobile,
        sendType: 'phone',
      };
      this.subscription.add(
        this.authService.sendForgetPinVerificationCode(payload).subscribe(() => {
          this.dismiss({ forgotPin: true });
          this.navController.navigateForward('forgot-pin?from=' + this.from);
          const msg = this.translateService.instant('tabs.account.page.forgetPin.sent', { phone: userProfile.user.mobile })
          this.inAppMessageService.simpleToast(msg, false);
        })
      );
    }
  }

  public forgetPin() {
    this.sendVerifyCode();
  }

  dismiss(options?: any) {
    this.modalController.dismiss(options);
  }

  public confirm() {
    if (this.myPin && this.myPin.length === 4) {
      this.subscription.add(
        this.authService.verifyPin({ pin: this.myPin }).subscribe(
          (res) => {
            if (res === 'ok') {
              this.modalController.dismiss({ verified: true });
            }
          },
          (err) => {
            this.myPin = null;
          })
      );
    }
  }
}

